import * as bscfi from '~/node_modules/admin-lte/plugins/bs-custom-file-input/bs-custom-file-input.min.js'

export default ({ app }, inject) => {
  inject('bscfi', bscfi)
}
